import { type PaymentTargetInfo } from '@a1/shared';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Grid2 from '@mui/material/Grid2';

interface MarkAsPaidDialogProps {
  open: boolean;
  onClose: () => void;
  onMarkAsPaid: (invoiceId: number, externalRefNo: string, externalSource: string) => void;
  targetInfo: PaymentTargetInfo | null;
  externalRefNo: string;
  externalSource: string;
  setExternalRefNo: React.Dispatch<React.SetStateAction<string>>;
  setExternalSource: React.Dispatch<React.SetStateAction<string>>;
  customAlertMessage?: string;
  customTitle?: string;
  loading?: boolean;
}

const MarkAsPaidDialog: React.FC<MarkAsPaidDialogProps> = ({
  open,
  onClose,
  onMarkAsPaid,
  targetInfo,
  externalRefNo,
  externalSource,
  setExternalRefNo,
  setExternalSource,
  customTitle,
  loading
}) => {
  const identifierToShow = targetInfo?.displayIdentifier || `ID: ${targetInfo?.id}`;
  const defaultTitle = `Mark ${identifierToShow} as Paid`;

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h4">{customTitle || defaultTitle}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h5">External Payment Details</Typography>

        <Grid2 size={12} mt={2}>
          <TextField
            id="externalTransactionRef"
            type="text"
            label="External Transaction ID/Reference"
            fullWidth
            value={externalRefNo}
            onChange={(e) => {
              setExternalRefNo(e.target.value);
            }}
          />
        </Grid2>
        <Grid2 size={12} mt={2}>
          <TextField
            id="externalSource"
            type="text"
            label="External Payment Method/Channel"
            fullWidth
            value={externalSource}
            onChange={(e) => {
              setExternalSource(e.target.value);
            }}
          />
        </Grid2>
        <Grid2 size={12} mt={2}>
          <Alert severity="info">
            <b>Warning: This action is irreversible.</b> Confirm payment has been received before proceeding. Only complete this section for
            payments processed outside our system.
          </Alert>
        </Grid2>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
            setExternalRefNo('');
            setExternalSource('');
          }}
        >
          Cancel
        </Button>
        <Button
          loading={loading}
          variant="contained"
          onClick={() => targetInfo && onMarkAsPaid(Number(targetInfo.id), externalRefNo, externalSource)}
        >
          Mark as Paid
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MarkAsPaidDialog;
